import React from 'react';
import styles from './AdStatisticsLoader.scss';


const AdStatisticsLoader = () => (
  <div className={styles.content}>
    <div className={`${styles.skeletonLoader} ${styles.title}`}></div>

    <div className={styles.card}>
      <div className={`${styles.skeletonLoader} ${styles.banner}`}></div>
      <div className={`${styles.skeletonLoader} ${styles.infoLine}`}></div>

      <div className={styles.metricsGrid}>
        <div className={`${styles.skeletonLoader} ${styles.metricCard}`}></div>
        <div className={`${styles.skeletonLoader} ${styles.metricCard}`}></div>
        <div className={`${styles.skeletonLoader} ${styles.metricCard}`}></div>
        <div className={`${styles.skeletonLoader} ${styles.metricCard}`}></div>
        <div className={`${styles.skeletonLoader} ${styles.metricCard}`}></div>
        <div className={`${styles.skeletonLoader} ${styles.metricCard}`}></div>
      </div>

      <div className={`${styles.skeletonLoader} ${styles.metricsSelect}`}></div>

      <div className={`${styles.skeletonLoader} ${styles.sectionTitle}`}></div>
      <div className={styles.periodControls}>
        <div className={`${styles.skeletonLoader} ${styles.periodBtn}`}></div>
        <div className={`${styles.skeletonLoader} ${styles.periodBtn}`}></div>
        <div className={`${styles.skeletonLoader} ${styles.periodDate}`}></div>
        <div className={`${styles.skeletonLoader} ${styles.periodDate}`}></div>
      </div>

      <div className={styles.chartSection}>
        <div className={styles.chartHeader}>
          <div className={`${styles.skeletonLoader} ${styles.chartTitle}`}></div>
          <div className={styles.chartSummary}>
            <div className={`${styles.skeletonLoader} ${styles.chartSummaryItem}`}></div>
            <div className={`${styles.skeletonLoader} ${styles.chartSummaryItem}`}></div>
          </div>
        </div>
        <div className={`${styles.skeletonLoader} ${styles.chart}`}></div>
      </div>

      <div className={`${styles.skeletonLoader} ${styles.sectionTitle}`}></div>
      <div className={styles.tipsGrid}>
        <div className={`${styles.skeletonLoader} ${styles.tipCard}`}></div>
      </div>
    </div>
  </div>
);

export default AdStatisticsLoader;



// WEBPACK FOOTER //
// ./src/containers/AdStatisticsPage/AdStatisticsLoader/index.tsx